module.exports = __webpack_public_path__ + "img/v-sumbol-topelt-varviline.c8c48bff.svg";